export const localConfig = {
  shortVideoAppUrl: 'https://h5.api.max.mgtv.com/app/index.html',

  appDlUrl: 'https://msite.api.mgtv.com/download.html', //todo 修改为域名

  androidActiveDlUrl: 'https://mobile.api.mgtv.com/thridGetApk?code=jmcp',
  androidDownloadUrl: 'https://mobile.api.mgtv.com/thridGetApk?code=jmcp',
  tencentDlUrl: '//a.app.qq.com/o/simple.jsp?pkgname=com.hunantv.imgo.activity&ckey=CK1394646518830',
  tencentActiveDlUrl: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.hunantv.imgo.activity&ckey=CK1394646518830',

  appleDlUrl: 'https://itunes.apple.com/app/apple-store/id629774477?pt=355474&ct=jmcp&mt=8',
  appleActiveDlUrl: 'https://itunes.apple.com/app/apple-store/id629774477?pt=355474&ct=jmcp&mt=8',

  ipadAppDlUrl: 'https://itunes.apple.com/app/apple-store/id489782456?pt=355474&ct=jmcp&mt=8',

  SCHEMA: 'imgotv',
  NEW_ANDROID_SCHEMA: 'hntvmobile',

  FROM: 'jmcp',
  CXID: '90f76kbev', // todo act 渠道id
  from: 'jmcp'
}
